<template>
  <section
    class="page-header-simple"
  >
    <h1
      class="page-header-simple__title"
      v-html="title"
    />
    <slot />
  </section>
</template>

<script setup lang="ts">

defineProps({
  title: { type: String, default: undefined, required: false }
})

</script>

<style scoped lang="postcss">
.page-header-simple {
  @mixin container-xl;
  margin-bottom: 3.5rem;
  display: flex;
  flex-direction: column;
  row-gap: 1.25rem;
  padding-top: 6rem;

  @media (--md) {
    row-gap: 1.5rem;
  }

  @media (--lg) {
    column-gap: 1.5rem;
  }

  @media (--xl) {
    margin-bottom: 5rem;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 1.75rem;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  @media (--xxl) {
    column-gap: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &__title {
    grid-column: 1 / -1;
    hyphens: manual;
    overflow-wrap: normal;
    word-break: normal;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    text-align: center;
    @mixin heading-h1-xl;
    @mixin heading-h1-small-md;

    @media (--sm) {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    @media (--md) {
      padding-left: 1.25rem;
      padding-right: 1.25rem;
    }

    @media (--lg) {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    @media (--xl) {
      padding-left: 0px;
      padding-right: 0px;
    }

    @media (--xxl) {
      grid-column: span 10 / span 10;
      grid-column-start: 2;
    }
  }
}
</style>
